import axios from 'axios'
import { HEADER, TOKENIDENTITY } from '../constants'
import { URL, LOCAL } from '../config'

export default class User {
    static INSTANCE = new User();

    User() { }

    register = async (token, user) => {
      const userToRegister = {
        id: 0,
        activo: true,
        fAlta: new Date(),
        nombres: user.name,
        apellidos: user.lastname,
        dni: user.dni,
        passport: user.passport,
        Mail: user.email,
        movil: user.mobile,
        aniversario: user.born,
        codigoPostal: user.cp,
        poblacion: user.population,
        bAceptaPublicidad: user.isPublicity,
        centroId: user.idCenter,
        iProvincia: user.idProvince,
        iMunicipio: user.idPopulation,
        iSexo: user.gender ? user.gender : 0,
        bConfirmado: false,
        bAceptaCondiciones: user.isPrivacity,
        hash: user.password,
        obsv: user.publicObserv,
        obsvPriv: user.privObserv,
        bBloqueado: !!(user.reason || user.reason !== ''),
        iMotivo: user.reason
      }

      if (!LOCAL) {
        let url = `${URL()}/Clientes`

        if (token) {
          return await axios.post(url, userToRegister, HEADER(token)).then(response => {
            return response.data
          })
        } else {
          return TOKENIDENTITY().then(headerWithToken => {
            return axios.post(url, userToRegister, headerWithToken).then(response => {
              return response.data
            })
          })
        }
      } else {
        return this.user
      }
    };

    check = async (token, id, dni, mobile, email) => {
      if (!LOCAL) {
        let url = `${URL()}/Clientes/check?idClient=${id}`
        if (dni) {
          url += `&dni=${dni}`
        } else if (mobile) {
          url += `&mobile=${mobile}`
        } else if (email) {
          url += `&email=${email}`
        }
        if (token) {
          return await axios.get(url, HEADER(token)).then(response => {
            return response
          })
        } else {
          return TOKENIDENTITY().then(headerWithToken => {
            return axios
              .get(url, headerWithToken).then(response => {
                return response
              })
          })
        }
      } else {
        return false
      }
    };

    changeUser = async (token, userId, user, changePassword = false, changeEmail = false) => {
      let userToChange = {}

      if (changePassword) {
        userToChange = {
          oldPassword: user.oldPassword,
          password: user.password,
          idencr: user.idencr
        }
      } else if (changeEmail) {
        userToChange = {
          Mail: user.email,
          //idencr: user.idencr
        }
      } else if (user) {
        const now = new Date()
        const d = new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate(), now.getHours(), now.getMinutes(), now.getSeconds()))

        userToChange = {
          nombres: user.name,
          apellidos: user.lastname,
          dni: user.dni,
          aniversario: user.born,
          movil: user.mobile,
          iSexo: user.gender ? user.gender : 0,
          codigoPostal: user.cp,
          iProvincia: user.idProvince,
          poblacion: user.population,
          centroId: user.idCenter,
          iMunicipio: user.idPopulation,
          bAceptaPublicidad: user.isPublicity,
          bAceptaCondiciones: user.isPrivacity,
          obsv: user.publicObserv,
          obsvPriv: user.privObserv,
          bBloqueado: !!user.reason,
          iMotivo: user.reason,
          usuarioId: user.userId,
          centroUsuarioId: user.centerUserId,
          fechaCliente: d.toISOString(),
          activo: user.active,
          idencr: user.idencr
        }
      } else {
        userToChange = {
          bConfirmado: true
        }
      }

      if (!LOCAL) {
        let url = `${URL()}/Clientes/part/${userId}`
        // console.log('URL for update:', url);
        // console.log('Sending update request:', userToChange);

        if (token) {
          return await axios.put(url, userToChange, HEADER(token))
            .then(response => {
              // console.log('Update response:', response);

              // If this is an email change and it was successful
              if (changeEmail && response.status === 200) {

                // console.log(`Email updated to ${user.email}`);
              }

              if (changePassword && response.status === 200) {

                // console.log(`User password updated`);
              }

              return user;

            })
            .catch(error => {
              console.error('Update error:', error.response || error);
              throw error;
            });
        } else {
          return TOKENIDENTITY().then(headerWithToken => {
            return axios
              .put(url, userToChange, headerWithToken).then(response => {
                return user
              })
          })
        }
      } else {
        return user
      }
    };

    getListReason = async (token) => {
      let url = `${URL()}/CvMotivos?i_kind=1`

      return await axios.get(url, HEADER(token)).then(response => {
        const parseResponse = response.data.map(item => {
          return {
            id: item.id,
            name: item.descr
          }
        })
        return parseResponse
      })
    };
}
